module.exports = __webpack_public_path__ + "static/img/datachuli1.f43f91d4.png";